// import React, { useEffect, useState } from "react";
// import {
//   Github,
//   ExternalLink,
//   Mail,
//   Linkedin,
//   ArrowUpRight,
// } from "lucide-react";

// const palette = {
//   void: "#12151C",
//   surface: "#1B1F29",
//   surface2: "#212635",
//   border: "#2A3040",
//   textPrimary: "#EDEFF4",
//   textSecondary: "#8B93A7",
//   textMuted: "#5C6478",
//   amber: "#E8A33D",
//   teal: "#3ECFA0",
// };

// const defaultData = {
//   name: "Bashay Tikur Gelaye",
//   role: "Backend Software Engineer & Founder",
//   tagline:
//     "I build the backend for a live e-commerce platform — event-driven microservices, RSA-secured service-to-service auth, and the AI/ML work that led me here.",
//   location: "Addis Ababa, Ethiopia",
//   email: "tikurbashay81@gmail.com",
//   phone: "+251 96 263 6887",
//   github: "https://github.com/bashay-tikur81",
//   linkedin: "https://linkedin.com/in/bashay-gelaye",
//   website: "https://afrogebeya.com",
//   bio: "Backend engineer and co-founder at Afrogebeya, an e-commerce platform for African markets — where I built JWT/RSA-based authentication and an event-driven microservices architecture spanning more than seven services communicating over Kafka. Before backend became the focus, I was a research assistant building Amharic NLP tools and fine-tuning multilingual transformers, which is still where a lot of my curiosity lives.",
//   skills: [
//     {
//       group: "Languages",
//       items: [
//         "Java ",
//         "Python ",
//         "C ",
//         "JavaScript ",
//         "SQL ",
//         "Shell scripting",
//       ],
//     },
//     {
//       group: "Backend & systems",
//       items: [
//         "Spring Boot ",
//         "Apache Kafka ",
//         "PostgreSQL ",
//         "MongoDB ",
//         "Redis ",
//         "Nginx ",
//         "Docker ",
//         "Linux",
//       ],
//     },
//     {
//       group: "Machine learning",
//       items: [
//         "PyTorch ",
//         "TensorFlow ",
//         "Scikit-learn ",
//         "Hugging Face ",
//         "LangChain ",
//         "FAISS ",
//       ],
//     },
//     {
//       group: "Tools & design",
//       items: ["Git ", "Postman ", "Figma ", "UML"],
//     },
//   ],
//   projects: [
//     {
//       name: "Afrogebeya",
//       status: "active",
//       description:
//         "E-commerce platform for African markets. Built JWT and RSA-based authentication, and an event-driven microservices architecture in Spring Boot — more than seven services communicating securely over Kafka, including real-time order notifications.",
//       stack: ["Spring Boot", "Kafka", "PostgreSQL", "RSA / JWT"],
//       links: {
//         repo: "https://github.com/bashay-tikur81",
//         live: "https://afrogebeya.com",
//       },
//     },
//     {
//       name: "Adaptive learning assistant",
//       status: "active",
//       description:
//         "A multimodal assistant that understands text, speech, and images, and adapts explanations to a learner's demonstrated level of understanding.",
//       stack: ["PyTorch ", "LangChain ", "Whisper ", "LLaVA ", "FAISS ", "OCR"],
//       links: { repo: "#", live: "#" },
//     },
//     {
//       name: "Recipe generator",
//       status: "shipped",
//       description:
//         "AI-agent-based recipe recommender that suggests dishes from a given set of ingredients — cut the average search time from 120 seconds to 90.",
//       stack: ["Hugging Face ", "Python ", "AI agents"],
//       links: { repo: "#", live: "#" },
//     },
//   ],
//   experience: [
//     {
//       period: "2024 — present",
//       role: "Backend Software Engineer & CEO",
//       org: "Afrogebeya Technologies",
//       detail:
//         "Built the platform's authentication (JWT/RSA) and event-driven microservices architecture on Kafka. Lead and mentor a team of backend developers and interns using Scrum, and direct UI/user research on the platform.",
//     },
//     {
//       period: "Oct 2023 — Jun 2025",
//       role: "Research Assistant",
//       org: "Areaya Zerihun Robotics Lab",
//       detail:
//         "Designed Amharic NLP tooling for web content and fine-tuned a multilingual transformer (XLM-RoBERTa) for semantic search. Co-authored a workshop paper on AI's impact on human creativity.",
//     },
//     {
//       period: "Jan 2024 — May 2024",
//       role: "Software Engineering Intern",
//       org: "Farka IT Solutions",
//       detail:
//         "Collaborated on backend APIs for a fault-tolerant student portal system, built monitoring dashboards for a marking system, and worked with PMs and designers to improve developer workflows.",
//     },
//   ],
//   education: {
//     school: "Mekelle Institute of Technology — Mekelle University",
//     degree: "B.Sc. in Information Technology Engineering",
//     period: "2019 — 2025",
//     gpa: "3.88 / 4.00",
//     note: "Graduated with honors. Timeline extended a year due to COVID-19 and conflict in Northern Ethiopia.",
//     coursework: [
//       "Artificial Intelligence ",
//       "Distributed Systems ",
//       "Cryptography & Network Security ",
//       "Database Systems ",
//       "Algorithms ",
//       "Computer Networks",
//     ],
//   },
// };

// function useReducedMotion() {
//   const [reduced, setReduced] = useState(false);
//   useEffect(() => {
//     const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
//     setReduced(mq.matches);
//     const handler = (e) => setReduced(e.matches);
//     mq.addEventListener("change", handler);
//     return () => mq.removeEventListener("change", handler);
//   }, []);
//   return reduced;
// }

// function SystemGraphic() {
//   const reduced = useReducedMotion();
//   const nodes = [
//     { id: "Microservice", label: "MICROSERVICE", x: 40, y: 30 },
//     { id: "kafka", label: "KAFKA", x: 40, y: 130 },
//     { id: "db", label: "DB", x: 260, y: 30 },
//     { id: "spring-security", label: "Spring Security", x: 260, y: 130 },
//   ];
//   const center = { x: 150, y: 80 };

//   return (
//     <svg
//       viewBox="0 0 300 170"
//       style={{ width: "100%", maxWidth: 360, height: "auto" }}
//       role="img"
//       aria-label="Diagram of API, queue, database, and cache nodes connecting to a central service node"
//     >
//       {nodes.map((n) => (
//         <line
//           key={`line-${n.id}`}
//           x1={n.x}
//           y1={n.y}
//           x2={center.x}
//           y2={center.y}
//           stroke={palette.border}
//           strokeWidth="1"
//         />
//       ))}

//       {!reduced &&
//         nodes.map((n, i) => (
//           <circle key={`pulse-${n.id}`} r="3" fill={palette.amber}>
//             <animateMotion
//               dur={`${2.4 + i * 0.4}s`}
//               repeatCount="indefinite"
//               path={`M${n.x},${n.y} L${center.x},${center.y}`}
//             />
//             <animate
//               attributeName="opacity"
//               values="0;1;1;0"
//               dur={`${2.4 + i * 0.4}s`}
//               repeatCount="indefinite"
//             />
//           </circle>
//         ))}

//       <circle
//         cx={center.x}
//         cy={center.y}
//         r="18"
//         fill={palette.surface2}
//         stroke={palette.teal}
//         strokeWidth="1.5"
//       />
//       <text
//         x={center.x}
//         y={center.y + 4}
//         textAnchor="middle"
//         fontFamily="'IBM Plex Mono', monospace"
//         fontSize="9"
//         fill={palette.teal}
//       >
//         you
//       </text>

//       {nodes.map((n) => (
//         <g key={`node-${n.id}`}>
//           <circle
//             cx={n.x}
//             cy={n.y}
//             r="14"
//             fill={palette.surface}
//             stroke={palette.border}
//             strokeWidth="1"
//           />
//           <text
//             x={n.x}
//             y={n.y + 28}
//             textAnchor="middle"
//             fontFamily="'IBM Plex Mono', monospace"
//             fontSize="9"
//             fill={palette.textSecondary}
//           >
//             {n.label}
//           </text>
//         </g>
//       ))}
//     </svg>
//   );
// }

// function Eyebrow({ children }) {
//   return (
//     <div
//       style={{
//         fontFamily: "'IBM Plex Mono', monospace",
//         fontSize: 13,
//         color: palette.amber,
//         letterSpacing: "0.02em",
//       }}
//       className="mb-3"
//     >
//       <span style={{ color: palette.textMuted }}>$ </span>
//       {children}
//     </div>
//   );
// }

// function SectionHeading({ children }) {
//   return (
//     <h2
//       style={{
//         fontFamily: "'Space Grotesk', sans-serif",
//         color: palette.textPrimary,
//         fontWeight: 600,
//       }}
//       className="text-2xl md:text-3xl mb-8"
//     >
//       {children}
//     </h2>
//   );
// }

// function Tag({ children, tone = "default" }) {
//   const color =
//     tone === "amber"
//       ? palette.amber
//       : tone === "teal"
//         ? palette.teal
//         : palette.textSecondary;
//   return (
//     <span
//       style={{
//         fontFamily: "'IBM Plex Mono', monospace",
//         fontSize: 12,
//         color,
//         border: `1px solid ${palette.border}`,
//         background: palette.surface,
//       }}
//       className="px-2.5 py-1 rounded-md inline-block"
//     >
//       {children}
//     </span>
//   );
// }

// export default function Portfolio({ data = defaultData }) {
//   const d = { ...defaultData, ...data };

//   return (
//     <div
//       style={{
//         background: palette.void,
//         color: palette.textPrimary,
//         minHeight: "100vh",
//       }}
//       className="w-full"
//     >
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=IBM+Plex+Sans:wght@400;500&family=IBM+Plex+Mono:wght@400;500&display=swap');
//         .body-font { font-family: 'IBM Plex Sans', sans-serif; }
//         a:focus-visible, button:focus-visible { outline: 2px solid ${palette.teal}; outline-offset: 2px; }
//       `}</style>

//       {/* Nav */}
//       <nav
//         style={{ borderBottom: `1px solid ${palette.border}` }}
//         className="sticky top-0 z-10 backdrop-blur bg-opacity-80"
//       >
//         <div
//           style={{ background: `${palette.void}CC` }}
//           className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between"
//         >
//           <span
//             style={{
//               fontFamily: "'Space Grotesk', sans-serif",
//               fontWeight: 600,
//             }}
//             className="text-sm"
//           >
//             {d.name}
//           </span>
//           <div
//             className="flex gap-5 body-font text-sm"
//             style={{ color: palette.textSecondary }}
//           >
//             <a href="#work" className="hover:text-white transition-colors">
//               work
//             </a>
//             <a href="#skills" className="hover:text-white transition-colors">
//               skills
//             </a>
//             <a
//               href="#experience"
//               className="hover:text-white transition-colors"
//             >
//               experience
//             </a>
//             <a href="#education" className="hover:text-white transition-colors">
//               education
//             </a>
//             <a href="#contact" className="hover:text-white transition-colors">
//               contact
//             </a>
//           </div>
//         </div>
//       </nav>

//       {/* Hero */}
//       <header className="max-w-4xl mx-auto px-6 pt-16 pb-20 md:pt-24 md:pb-28 flex flex-col md:flex-row items-center gap-12">
//         <div className="flex-1">
//           <div
//             style={{
//               fontFamily: "'IBM Plex Mono', monospace",
//               color: palette.teal,
//               fontSize: 13,
//             }}
//             className="mb-4"
//           >
//             {d.location}
//           </div>
//           <h1
//             style={{
//               fontFamily: "'Space Grotesk', sans-serif",
//               fontWeight: 700,
//               lineHeight: 1.1,
//             }}
//             className="text-4xl md:text-5xl mb-4"
//           >
//             {d.name}
//           </h1>
//           <p
//             style={{ color: palette.amber }}
//             className="body-font text-lg mb-5"
//           >
//             {d.role}
//           </p>
//           <p
//             style={{ color: palette.textSecondary }}
//             className="body-font text-base leading-relaxed mb-8 max-w-md"
//           >
//             {d.tagline}
//           </p>
//           <div className="flex gap-3">
//             <a
//               href="#work"
//               style={{ background: palette.amber, color: palette.void }}
//               className="body-font text-sm font-medium px-4 py-2.5 rounded-md inline-flex items-center gap-1.5 hover:opacity-90 transition-opacity"
//             >
//               View work <ArrowUpRight size={15} />
//             </a>
//             <a
//               href={`mailto:${d.email}`}
//               style={{
//                 border: `1px solid ${palette.border}`,
//                 color: palette.textPrimary,
//               }}
//               className="body-font text-sm font-medium px-4 py-2.5 rounded-md hover:border-white transition-colors"
//             >
//               Get in touch
//             </a>
//           </div>
//         </div>
//         <div className="flex-shrink-0">
//           <SystemGraphic />
//         </div>
//       </header>

//       {/* About */}
//       <section className="max-w-4xl mx-auto px-6 pb-20">
//         <Eyebrow>whoami</Eyebrow>
//         <p
//           style={{ color: palette.textSecondary }}
//           className="body-font text-base leading-relaxed max-w-2xl"
//         >
//           {d.bio}
//         </p>
//       </section>

//       {/* Projects */}
//       <section id="work" className="max-w-4xl mx-auto px-6 pb-20">
//         <Eyebrow>ls ./projects</Eyebrow>
//         <SectionHeading>Selected work</SectionHeading>
//         <div className="grid gap-4">
//           {d.projects.map((p) => (
//             <div
//               key={p.name}
//               style={{
//                 background: palette.surface,
//                 border: `1px solid ${palette.border}`,
//               }}
//               className="rounded-lg p-5 md:p-6"
//             >
//               <div className="flex items-start justify-between mb-3 gap-4">
//                 <div className="flex items-center gap-2.5">
//                   <span
//                     style={{
//                       width: 7,
//                       height: 7,
//                       borderRadius: "50%",
//                       background:
//                         p.status === "active" ? palette.teal : palette.amber,
//                       display: "inline-block",
//                     }}
//                   />
//                   <h3
//                     style={{
//                       fontFamily: "'Space Grotesk', sans-serif",
//                       fontWeight: 600,
//                     }}
//                     className="text-lg"
//                   >
//                     {p.name}
//                   </h3>
//                 </div>
//                 <div className="flex gap-3 flex-shrink-0">
//                   <a
//                     href={p.links.repo}
//                     aria-label={`${p.name} repository`}
//                     style={{ color: palette.textSecondary }}
//                     className="hover:text-white transition-colors"
//                   >
//                     <Github size={17} />
//                   </a>
//                   <a
//                     href={p.links.live}
//                     aria-label={`${p.name} live link`}
//                     style={{ color: palette.textSecondary }}
//                     className="hover:text-white transition-colors"
//                   >
//                     <ExternalLink size={17} />
//                   </a>
//                 </div>
//               </div>
//               <p
//                 style={{ color: palette.textSecondary }}
//                 className="body-font text-sm leading-relaxed mb-4"
//               >
//                 {p.description}
//               </p>
//               <div className="flex flex-wrap gap-2">
//                 {p.stack.map((s) => (
//                   <Tag key={s}>{s}</Tag>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Skills */}
//       <section id="skills" className="max-w-4xl mx-auto px-6 pb-20">
//         <Eyebrow>cat skills.json</Eyebrow>
//         <SectionHeading>Toolset</SectionHeading>
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//           {d.skills.map((group) => (
//             <div key={group.group}>
//               <p
//                 style={{
//                   fontFamily: "'IBM Plex Mono', monospace",
//                   color: palette.textMuted,
//                   fontSize: 12,
//                 }}
//                 className="mb-2.5 uppercase tracking-wide"
//               >
//                 {group.group}
//               </p>
//               <div className="flex flex-wrap gap-2">
//                 {group.items.map((item) => (
//                   <Tag key={item} tone="teal">
//                     {item}
//                   </Tag>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Experience */}
//       <section id="experience" className="max-w-4xl mx-auto px-6 pb-20">
//         <Eyebrow>git log --experience</Eyebrow>
//         <SectionHeading>Experience</SectionHeading>
//         <div
//           style={{ borderLeft: `1px solid ${palette.border}` }}
//           className="pl-6 space-y-8"
//         >
//           {d.experience.map((e) => (
//             <div key={e.role + e.period} style={{ position: "relative" }}>
//               <span
//                 style={{
//                   position: "absolute",
//                   left: -29,
//                   top: 6,
//                   width: 8,
//                   height: 8,
//                   borderRadius: "50%",
//                   background: palette.amber,
//                 }}
//               />
//               <p
//                 style={{
//                   fontFamily: "'IBM Plex Mono', monospace",
//                   color: palette.textMuted,
//                   fontSize: 12,
//                 }}
//                 className="mb-1"
//               >
//                 {e.period}
//               </p>
//               <h3
//                 style={{
//                   fontFamily: "'Space Grotesk', sans-serif",
//                   fontWeight: 600,
//                 }}
//                 className="text-lg mb-1"
//               >
//                 {e.role}{" "}
//                 <span style={{ color: palette.textSecondary, fontWeight: 400 }}>
//                   · {e.org}
//                 </span>
//               </h3>
//               <p
//                 style={{ color: palette.textSecondary }}
//                 className="body-font text-sm leading-relaxed max-w-xl"
//               >
//                 {e.detail}
//               </p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Education */}
//       <section id="education" className="max-w-4xl mx-auto px-6 pb-20">
//         <Eyebrow>cat education.md</Eyebrow>
//         <SectionHeading>Education</SectionHeading>
//         <div
//           style={{
//             background: palette.surface,
//             border: `1px solid ${palette.border}`,
//           }}
//           className="rounded-lg p-5 md:p-6"
//         >
//           <div className="flex flex-wrap items-baseline justify-between gap-2 mb-1">
//             <h3
//               style={{
//                 fontFamily: "'Space Grotesk', sans-serif",
//                 fontWeight: 600,
//               }}
//               className="text-lg"
//             >
//               {d.education.degree}
//             </h3>
//             <span
//               style={{
//                 fontFamily: "'IBM Plex Mono', monospace",
//                 color: palette.teal,
//                 fontSize: 12,
//               }}
//             >
//               GPA {d.education.gpa}
//             </span>
//           </div>
//           <p
//             style={{ color: palette.textSecondary }}
//             className="body-font text-sm mb-1"
//           >
//             {d.education.school}
//           </p>
//           <p
//             style={{
//               fontFamily: "'IBM Plex Mono', monospace",
//               color: palette.textMuted,
//               fontSize: 12,
//             }}
//             className="mb-4"
//           >
//             {d.education.period}
//           </p>
//           <p
//             style={{ color: palette.textSecondary }}
//             className="body-font text-sm leading-relaxed mb-4 max-w-xl"
//           >
//             {d.education.note}
//           </p>
//           <div className="flex flex-wrap gap-2">
//             {d.education.coursework.map((c) => (
//               <Tag key={c}>{c}</Tag>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Contact / footer */}
//       <footer
//         id="contact"
//         style={{ borderTop: `1px solid ${palette.border}` }}
//         className="max-w-4xl mx-auto px-6 py-16"
//       >
//         <Eyebrow>mail --to={d.email}</Eyebrow>
//         <h2
//           style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600 }}
//           className="text-2xl md:text-3xl mb-6 max-w-md"
//         >
//           Building Enterprise applications? Let's talk.
//         </h2>
//         <div className="flex flex-wrap gap-4 body-font text-sm">
//           <a
//             href={`mailto:${d.email}`}
//             style={{ color: palette.textPrimary }}
//             className="inline-flex items-center gap-2 hover:text-amber-400 transition-colors"
//           >
//             <Mail size={16} style={{ color: palette.amber }} /> {d.email}
//           </a>
//           <a
//             href={d.github}
//             style={{ color: palette.textPrimary }}
//             className="inline-flex items-center gap-2 hover:text-amber-400 transition-colors"
//           >
//             <Github size={16} style={{ color: palette.textSecondary }} /> GitHub
//           </a>
//           <a
//             href={d.linkedin}
//             style={{ color: palette.textPrimary }}
//             className="inline-flex items-center gap-2 hover:text-amber-400 transition-colors"
//           >
//             <Linkedin size={16} style={{ color: palette.textSecondary }} />{" "}
//             LinkedIn
//           </a>
//           <a
//             href={d.website}
//             style={{ color: palette.textPrimary }}
//             className="inline-flex items-center gap-2 hover:text-amber-400 transition-colors"
//           >
//             <ExternalLink size={16} style={{ color: palette.textSecondary }} />{" "}
//             afrogebeya.com
//           </a>
//           <span
//             style={{ color: palette.textSecondary }}
//             className="inline-flex items-center gap-2"
//           >
//             {d.phone}
//           </span>
//         </div>
//       </footer>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import {
  Github,
  ExternalLink,
  Mail,
  Linkedin,
  ArrowUpRight,
  FileDown,
} from "lucide-react";

const palette = {
  void: "#12151C",
  surface: "#1B1F29",
  surface2: "#212635",
  border: "#2A3040",
  textPrimary: "#EDEFF4",
  textSecondary: "#8B93A7",
  textMuted: "#5C6478",
  amber: "#E8A33D",
  teal: "#3ECFA0",
};

const defaultData = {
  name: "Bashay Tikur Gelaye",
  role: "Backend Software Engineer & Founder",
  tagline:
    "I build the backend for a live e-commerce platform — event-driven microservices, RSA-secured service-to-service auth, and the AI/data work that led me here.",
  location: "Addis Ababa, Ethiopia",
  email: "tikurbashay81@gmail.com",
  phone: "+251 96 263 6887",
  github: "https://github.com/bashay-tikur81",
  linkedin: "https://linkedin.com/in/bashay-gelaye",
  website: "https://afrogebeya.com",
  resumeUrl: "/resume.pdf",
  bio: "Backend engineer and co-founder at Afrogebeya, an e-commerce platform for African markets — where I built JWT/RSA-based authentication and an event-driven microservices architecture spanning more than seven services communicating over Kafka. Before backend became the focus, I was a research assistant building Amharic NLP tools and fine-tuning multilingual transformers, and I still take on data science projects — from geocoding population data across Tigray to AI systems for learning and recommendation — whenever I get the chance.",
  skills: [
    {
      group: "Languages",
      items: ["Java", "Python", "C", "JavaScript", "SQL", "Shell scripting"],
    },
    {
      group: "Backend & systems",
      items: [
        "Spring Boot",
        "Apache Kafka",
        "PostgreSQL",
        "MongoDB",
        "Redis",
        "Nginx",
        "Docker",
        "Linux",
      ],
    },
    {
      group: "Machine learning",
      items: [
        "PyTorch",
        "TensorFlow",
        "Scikit-learn",
        "Hugging Face",
        "LangChain",
        "FAISS",
      ],
    },
    {
      group: "Data science",
      items: [
        "Pandas",
        "Hadoop",
        "Anaconda",
        "Google Maps API",
        "Folium / QGIS",
        "Data mining",
      ],
    },
    {
      group: "Tools & design",
      items: ["Git", "Postman", "Figma", "UML"],
    },
  ],
  projects: [
    {
      name: "Afrogebeya",
      status: "active",
      description:
        "E-commerce platform for African markets. Built JWT and RSA-based authentication, and an event-driven microservices architecture in Spring Boot — more than seven services communicating securely over Kafka, including real-time order notifications. Now serving 100+ active users.",
      stack: ["Spring Boot", "Kafka", "PostgreSQL", "Docker", "RSA / JWT"],
      links: {
        repo: "https://github.com/bashay-tikur81",
        live: "https://afrogebeya.com",
      },
    },
    {
      name: "Population & service data mapping",
      status: "shipped",
      description:
        "Data mining course project extracting and geocoding population and service-location data for seven zones in Tigray via the Google Maps/Places API, then structuring the results for analysis and visualization.",
      stack: ["Python", "Google Maps API", "Pandas", "Requests", "Folium / QGIS"],
      links: { repo: "#", live: "#" },
    },
    {
      name: "Adaptive learning assistant",
      status: "active",
      description:
        "A multimodal assistant that understands text, speech, and images, and adapts explanations to a learner's demonstrated level of understanding.",
      stack: ["PyTorch", "LangChain", "Whisper", "LLaVA", "FAISS", "OCR"],
      links: { repo: "#", live: "#" },
    },
    {
      name: "Big data analysis",
      status: "shipped",
      description:
        "A set of coursework and independent projects cleaning, exploring, and visualizing large datasets — from distributed processing with Hadoop to exploratory analysis in Pandas and Anaconda.",
      stack: ["Python", "Pandas", "Hadoop", "Anaconda"],
      links: { repo: "#", live: "#" },
    },
    {
      name: "Recipe generator",
      status: "shipped",
      description:
        "AI-agent-based recipe recommender that suggests dishes from a given set of ingredients — cut the average search time from 120 seconds to 90.",
      stack: ["Hugging Face", "Python", "AI agents"],
      links: { repo: "#", live: "#" },
    },
  ],
  experience: [
    {
      period: "2024 — present",
      role: "Backend Software Engineer & CEO",
      org: "Afrogebeya Technologies",
      detail:
        "Built the platform's authentication (JWT/RSA) and event-driven microservices architecture on Kafka. Lead and mentor a team of backend developers and interns using Scrum, and direct UI/user research on the platform.",
    },
    {
      period: "Oct 2023 — Jun 2025",
      role: "Research Assistant",
      org: "Areaya Zerihun Robotics Lab",
      detail:
        "Designed Amharic NLP tooling for web content and fine-tuned a multilingual transformer (XLM-RoBERTa) for semantic search. Co-authored a workshop paper on AI's impact on human creativity.",
    },
    {
      period: "Jan 2024 — May 2024",
      role: "Software Engineering Intern",
      org: "Farka IT Solutions",
      detail:
        "Collaborated on backend APIs for a fault-tolerant student portal system, built monitoring dashboards for a marking system, and worked with PMs and designers to improve developer workflows.",
    },
  ],
  leadership: [
    {
      period: "Jan 2025 — present",
      role: "Assistant Manager",
      org: "Warka Import — Human Medicine & Medical Devices",
      detail:
        "Lead a team of 5, coordinate international import operations, and helped grow the company to 8 million ETB in capital.",
    },
    {
      period: "Dec 2022 — Jan 2025",
      role: "Assistant Manager",
      org: "Raya Pharmaceuticals Import",
      detail:
        "Organized monthly professional-development seminars for 12 employees; received the Research and Development Leader Award.",
    },
    {
      period: "3 years, secondary school",
      role: "Health & Life-Skills Educator",
      org: "OSSHD",
      detail:
        "Taught menstrual health and led discussions on peer pressure and career planning for girls in underserved communities.",
    },
    {
      period: "Post-conflict period",
      role: "Volunteer",
      org: "World Food Programme",
      detail:
        "Supported humanitarian distribution of wheat and cooking oil to displaced families in Tigray.",
    },
  ],
  education: {
    school: "Mekelle Institute of Technology — Mekelle University",
    degree: "B.Sc. in Information Technology Engineering",
    period: "2019 — 2025",
    gpa: "3.88 / 4.00",
    note: "Graduated with honors. Timeline extended due to COVID-19 and conflict in Northern Ethiopia.",
    coursework: [
      "Artificial Intelligence",
      "Distributed Systems",
      "Data Mining",
      "Cryptography & Network Security",
      "Database Systems",
      "Algorithms",
      "Computer Networks",
    ],
  },
  publications: [
    {
      title: "The impact of AI on human creativity",
      venue: "Workshop paper, co-authored — Areaya Zerihun Lab",
      period: "2023 — 2025",
    },
  ],
};

function useReducedMotion() {
  const [reduced, setReduced] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReduced(mq.matches);
    const handler = (e) => setReduced(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);
  return reduced;
}

function SystemGraphic() {
  const reduced = useReducedMotion();
  const nodes = [
    { id: "Microservice", label: "MICROSERVICE", x: 40, y: 30 },
    { id: "kafka", label: "KAFKA", x: 40, y: 130 },
    { id: "db", label: "DB", x: 260, y: 30 },
    { id: "spring-security", label: "Spring Security", x: 260, y: 130 },
  ];
  const center = { x: 150, y: 80 };

  return (
    <svg
      viewBox="0 0 300 170"
      style={{ width: "100%", maxWidth: 360, height: "auto" }}
      role="img"
      aria-label="Diagram of API, queue, database, and cache nodes connecting to a central service node"
    >
      {nodes.map((n) => (
        <line
          key={`line-${n.id}`}
          x1={n.x}
          y1={n.y}
          x2={center.x}
          y2={center.y}
          stroke={palette.border}
          strokeWidth="1"
        />
      ))}

      {!reduced &&
        nodes.map((n, i) => (
          <circle key={`pulse-${n.id}`} r="3" fill={palette.amber}>
            <animateMotion
              dur={`${2.4 + i * 0.4}s`}
              repeatCount="indefinite"
              path={`M${n.x},${n.y} L${center.x},${center.y}`}
            />
            <animate
              attributeName="opacity"
              values="0;1;1;0"
              dur={`${2.4 + i * 0.4}s`}
              repeatCount="indefinite"
            />
          </circle>
        ))}

      <circle
        cx={center.x}
        cy={center.y}
        r="18"
        fill={palette.surface2}
        stroke={palette.teal}
        strokeWidth="1.5"
      />
      <text
        x={center.x}
        y={center.y + 4}
        textAnchor="middle"
        fontFamily="'IBM Plex Mono', monospace"
        fontSize="9"
        fill={palette.teal}
      >
        you
      </text>

      {nodes.map((n) => (
        <g key={`node-${n.id}`}>
          <circle
            cx={n.x}
            cy={n.y}
            r="14"
            fill={palette.surface}
            stroke={palette.border}
            strokeWidth="1"
          />
          <text
            x={n.x}
            y={n.y + 28}
            textAnchor="middle"
            fontFamily="'IBM Plex Mono', monospace"
            fontSize="9"
            fill={palette.textSecondary}
          >
            {n.label}
          </text>
        </g>
      ))}
    </svg>
  );
}

function Eyebrow({ children }) {
  return (
    <div
      style={{
        fontFamily: "'IBM Plex Mono', monospace",
        fontSize: 13,
        color: palette.amber,
        letterSpacing: "0.02em",
      }}
      className="mb-3"
    >
      <span style={{ color: palette.textMuted }}>$ </span>
      {children}
    </div>
  );
}

function SectionHeading({ children }) {
  return (
    <h2
      style={{
        fontFamily: "'Space Grotesk', sans-serif",
        color: palette.textPrimary,
        fontWeight: 600,
      }}
      className="text-2xl md:text-3xl mb-8"
    >
      {children}
    </h2>
  );
}

function Tag({ children, tone = "default" }) {
  const color =
    tone === "amber"
      ? palette.amber
      : tone === "teal"
        ? palette.teal
        : palette.textSecondary;
  return (
    <span
      style={{
        fontFamily: "'IBM Plex Mono', monospace",
        fontSize: 12,
        color,
        border: `1px solid ${palette.border}`,
        background: palette.surface,
      }}
      className="px-2.5 py-1 rounded-md inline-block"
    >
      {children}
    </span>
  );
}

function TimelineList({ items, dotColor = palette.amber }) {
  return (
    <div
      style={{ borderLeft: `1px solid ${palette.border}` }}
      className="pl-6 space-y-8"
    >
      {items.map((e) => (
        <div key={e.role + e.period + e.org} style={{ position: "relative" }}>
          <span
            style={{
              position: "absolute",
              left: -29,
              top: 6,
              width: 8,
              height: 8,
              borderRadius: "50%",
              background: dotColor,
            }}
          />
          <p
            style={{
              fontFamily: "'IBM Plex Mono', monospace",
              color: palette.textMuted,
              fontSize: 12,
            }}
            className="mb-1"
          >
            {e.period}
          </p>
          <h3
            style={{
              fontFamily: "'Space Grotesk', sans-serif",
              fontWeight: 600,
            }}
            className="text-lg mb-1"
          >
            {e.role}{" "}
            <span style={{ color: palette.textSecondary, fontWeight: 400 }}>
              · {e.org}
            </span>
          </h3>
          <p
            style={{ color: palette.textSecondary }}
            className="body-font text-sm leading-relaxed max-w-xl"
          >
            {e.detail}
          </p>
        </div>
      ))}
    </div>
  );
}

export default function Portfolio({ data = defaultData }) {
  const d = { ...defaultData, ...data };

  return (
    <div
      style={{
        background: palette.void,
        color: palette.textPrimary,
        minHeight: "100vh",
      }}
      className="w-full"
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=IBM+Plex+Sans:wght@400;500&family=IBM+Plex+Mono:wght@400;500&display=swap');
        .body-font { font-family: 'IBM Plex Sans', sans-serif; }
        a:focus-visible, button:focus-visible { outline: 2px solid ${palette.teal}; outline-offset: 2px; }
      `}</style>

      {/* Nav */}
      <nav
        style={{ borderBottom: `1px solid ${palette.border}` }}
        className="sticky top-0 z-10 backdrop-blur bg-opacity-80"
      >
        <div
          style={{ background: `${palette.void}CC` }}
          className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between"
        >
          <span
            style={{
              fontFamily: "'Space Grotesk', sans-serif",
              fontWeight: 600,
            }}
            className="text-sm"
          >
            {d.name}
          </span>
          <div
            className="hidden sm:flex gap-5 body-font text-sm"
            style={{ color: palette.textSecondary }}
          >
            <a href="#work" className="hover:text-white transition-colors">
              work
            </a>
            <a href="#skills" className="hover:text-white transition-colors">
              skills
            </a>
            <a
              href="#experience"
              className="hover:text-white transition-colors"
            >
              experience
            </a>
            <a
              href="#leadership"
              className="hover:text-white transition-colors"
            >
              leadership
            </a>
            <a href="#education" className="hover:text-white transition-colors">
              education
            </a>
            <a href="#contact" className="hover:text-white transition-colors">
              contact
            </a>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <header className="max-w-4xl mx-auto px-6 pt-16 pb-20 md:pt-24 md:pb-28 flex flex-col md:flex-row items-center gap-12">
        <div className="flex-1">
          <div
            style={{
              fontFamily: "'IBM Plex Mono', monospace",
              color: palette.teal,
              fontSize: 13,
            }}
            className="mb-4"
          >
            {d.location}
          </div>
          <h1
            style={{
              fontFamily: "'Space Grotesk', sans-serif",
              fontWeight: 700,
              lineHeight: 1.1,
            }}
            className="text-4xl md:text-5xl mb-4"
          >
            {d.name}
          </h1>
          <p
            style={{ color: palette.amber }}
            className="body-font text-lg mb-5"
          >
            {d.role}
          </p>
          <p
            style={{ color: palette.textSecondary }}
            className="body-font text-base leading-relaxed mb-8 max-w-md"
          >
            {d.tagline}
          </p>
          <div className="flex flex-wrap gap-3">
            <a
              href="#work"
              style={{ background: palette.amber, color: palette.void }}
              className="body-font text-sm font-medium px-4 py-2.5 rounded-md inline-flex items-center gap-1.5 hover:opacity-90 transition-opacity"
            >
              View work <ArrowUpRight size={15} />
            </a>
            <a
              href={`mailto:${d.email}`}
              style={{
                border: `1px solid ${palette.border}`,
                color: palette.textPrimary,
              }}
              className="body-font text-sm font-medium px-4 py-2.5 rounded-md hover:border-white transition-colors"
            >
              Get in touch
            </a>
            <a
              href={d.resumeUrl}
              style={{
                border: `1px solid ${palette.border}`,
                color: palette.textSecondary,
              }}
              className="body-font text-sm font-medium px-4 py-2.5 rounded-md inline-flex items-center gap-1.5 hover:text-white hover:border-white transition-colors"
            >
              <FileDown size={15} /> Resume
            </a>
          </div>
        </div>
        <div className="flex-shrink-0">
          <SystemGraphic />
        </div>
      </header>

      {/* About */}
      <section className="max-w-4xl mx-auto px-6 pb-20">
        <Eyebrow>whoami</Eyebrow>
        <p
          style={{ color: palette.textSecondary }}
          className="body-font text-base leading-relaxed max-w-2xl"
        >
          {d.bio}
        </p>
      </section>

      {/* Projects */}
      <section id="work" className="max-w-4xl mx-auto px-6 pb-20">
        <Eyebrow>ls ./projects</Eyebrow>
        <SectionHeading>Selected work</SectionHeading>
        <div className="grid gap-4">
          {d.projects.map((p) => (
            <div
              key={p.name}
              style={{
                background: palette.surface,
                border: `1px solid ${palette.border}`,
              }}
              className="rounded-lg p-5 md:p-6"
            >
              <div className="flex items-start justify-between mb-3 gap-4">
                <div className="flex items-center gap-2.5">
                  <span
                    style={{
                      width: 7,
                      height: 7,
                      borderRadius: "50%",
                      background:
                        p.status === "active" ? palette.teal : palette.amber,
                      display: "inline-block",
                    }}
                  />
                  <h3
                    style={{
                      fontFamily: "'Space Grotesk', sans-serif",
                      fontWeight: 600,
                    }}
                    className="text-lg"
                  >
                    {p.name}
                  </h3>
                </div>
                <div className="flex gap-3 flex-shrink-0">
                  <a
                    href={p.links.repo}
                    aria-label={`${p.name} repository`}
                    style={{ color: palette.textSecondary }}
                    className="hover:text-white transition-colors"
                  >
                    <Github size={17} />
                  </a>
                  <a
                    href={p.links.live}
                    aria-label={`${p.name} live link`}
                    style={{ color: palette.textSecondary }}
                    className="hover:text-white transition-colors"
                  >
                    <ExternalLink size={17} />
                  </a>
                </div>
              </div>
              <p
                style={{ color: palette.textSecondary }}
                className="body-font text-sm leading-relaxed mb-4"
              >
                {p.description}
              </p>
              <div className="flex flex-wrap gap-2">
                {p.stack.map((s) => (
                  <Tag key={s}>{s}</Tag>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Skills */}
      <section id="skills" className="max-w-4xl mx-auto px-6 pb-20">
        <Eyebrow>cat skills.json</Eyebrow>
        <SectionHeading>Toolset</SectionHeading>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {d.skills.map((group) => (
            <div key={group.group}>
              <p
                style={{
                  fontFamily: "'IBM Plex Mono', monospace",
                  color: palette.textMuted,
                  fontSize: 12,
                }}
                className="mb-2.5 uppercase tracking-wide"
              >
                {group.group}
              </p>
              <div className="flex flex-wrap gap-2">
                {group.items.map((item) => (
                  <Tag key={item} tone="teal">
                    {item}
                  </Tag>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Experience */}
      <section id="experience" className="max-w-4xl mx-auto px-6 pb-20">
        <Eyebrow>git log --experience</Eyebrow>
        <SectionHeading>Experience</SectionHeading>
        <TimelineList items={d.experience} dotColor={palette.amber} />
      </section>

      {/* Leadership & community */}
      <section id="leadership" className="max-w-4xl mx-auto px-6 pb-20">
        <Eyebrow>git log --leadership</Eyebrow>
        <SectionHeading>Leadership &amp; community</SectionHeading>
        <TimelineList items={d.leadership} dotColor={palette.teal} />
        <p
          style={{ color: palette.textMuted }}
          className="body-font text-sm mt-6"
        >
          A fuller record of community and volunteer work is on my resume.
        </p>
      </section>

      {/* Education */}
      <section id="education" className="max-w-4xl mx-auto px-6 pb-20">
        <Eyebrow>cat education.md</Eyebrow>
        <SectionHeading>Education</SectionHeading>
        <div
          style={{
            background: palette.surface,
            border: `1px solid ${palette.border}`,
          }}
          className="rounded-lg p-5 md:p-6"
        >
          <div className="flex flex-wrap items-baseline justify-between gap-2 mb-1">
            <h3
              style={{
                fontFamily: "'Space Grotesk', sans-serif",
                fontWeight: 600,
              }}
              className="text-lg"
            >
              {d.education.degree}
            </h3>
            <span
              style={{
                fontFamily: "'IBM Plex Mono', monospace",
                color: palette.teal,
                fontSize: 12,
              }}
            >
              GPA {d.education.gpa}
            </span>
          </div>
          <p
            style={{ color: palette.textSecondary }}
            className="body-font text-sm mb-1"
          >
            {d.education.school}
          </p>
          <p
            style={{
              fontFamily: "'IBM Plex Mono', monospace",
              color: palette.textMuted,
              fontSize: 12,
            }}
            className="mb-4"
          >
            {d.education.period}
          </p>
          <p
            style={{ color: palette.textSecondary }}
            className="body-font text-sm leading-relaxed mb-4 max-w-xl"
          >
            {d.education.note}
          </p>
          <div className="flex flex-wrap gap-2">
            {d.education.coursework.map((c) => (
              <Tag key={c}>{c}</Tag>
            ))}
          </div>
        </div>

        {d.publications && d.publications.length > 0 && (
          <div className="mt-8">
            <p
              style={{
                fontFamily: "'IBM Plex Mono', monospace",
                color: palette.textMuted,
                fontSize: 12,
              }}
              className="mb-3 uppercase tracking-wide"
            >
              Publications
            </p>
            <div className="space-y-3">
              {d.publications.map((pub) => (
                <div key={pub.title}>
                  <p
                    style={{ color: palette.textPrimary }}
                    className="body-font text-sm"
                  >
                    {pub.title}
                  </p>
                  <p
                    style={{ color: palette.textMuted }}
                    className="body-font text-xs"
                  >
                    {pub.venue} · {pub.period}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
      </section>

      {/* Contact / footer */}
      <footer
        id="contact"
        style={{ borderTop: `1px solid ${palette.border}` }}
        className="max-w-4xl mx-auto px-6 py-16"
      >
        <Eyebrow>mail --to={d.email}</Eyebrow>
        <h2
          style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600 }}
          className="text-2xl md:text-3xl mb-6 max-w-md"
        >
          Building enterprise applications, or working on AI for African
          languages? Let's talk.
        </h2>
        <div className="flex flex-wrap gap-4 body-font text-sm">
          <a
            href={`mailto:${d.email}`}
            style={{ color: palette.textPrimary }}
            className="inline-flex items-center gap-2 hover:text-amber-400 transition-colors"
          >
            <Mail size={16} style={{ color: palette.amber }} /> {d.email}
          </a>
          <a
            href={d.github}
            style={{ color: palette.textPrimary }}
            className="inline-flex items-center gap-2 hover:text-amber-400 transition-colors"
          >
            <Github size={16} style={{ color: palette.textSecondary }} /> GitHub
          </a>
          <a
            href={d.linkedin}
            style={{ color: palette.textPrimary }}
            className="inline-flex items-center gap-2 hover:text-amber-400 transition-colors"
          >
            <Linkedin size={16} style={{ color: palette.textSecondary }} />{" "}
            LinkedIn
          </a>
          <a
            href={d.website}
            style={{ color: palette.textPrimary }}
            className="inline-flex items-center gap-2 hover:text-amber-400 transition-colors"
          >
            <ExternalLink size={16} style={{ color: palette.textSecondary }} />{" "}
            afrogebeya.com
          </a>
          <span
            style={{ color: palette.textSecondary }}
            className="inline-flex items-center gap-2"
          >
            {d.phone}
          </span>
        </div>
      </footer>
    </div>
  );
}